import { LitElement, html, css } from 'lit-element'

class SbtMapMarker extends LitElement {

  static get is() { return 'sbt-map-marker' }

  static get styles() {
    return css`
        :host {
          display: block;
          padding: 0;
        }
    `
  }

  render () {
    return html`<slot @sbt-map-element-attached="${this.updateMarkerElements}" @slotchange="${this.updateMarkerElements}"></slot>`
  }

  static get properties() {
    return {

      coordinates: {
        type: Array,
      },

      color: {
        type: String
      },

      offset: {
        type: Array
      }
    }
  }

  set map(map) {
    if (map !== this._map) {
      this._map = map
      map ? this.initMarker(map) : (this.marker && this.marker.remove())
      this.updateMarkerElements()
    }
  }

  get map() {
    return this._map
  }

  set color(color) {
    this.initialMarkerOptions.color = color
  }

  get color() {
    return this.initialMarkerOptions.color
  }

  set coordinates(lngLatLike) {
    this.marker && this.marker.setLngLat(lngLatLike)
    this._lngLat = lngLatLike
  }

  get coordinates() {
    return this.marker ? this.marker.getLngLat() : this._lngLat
  }

  set element(element) {
    this.initialMarkerOptions.element = element
  }

  get element() {
    return this.marker ? this.marker.getElement() : this.initialMarkerOptions.element
  }

  constructor (props) {
    super(props)
    this.initialMarkerOptions = {
      element: null,
      offset: [0, 0],
      color: '#015b86'
    }
    this._lngLat = [0, 0]
    this._map = null
    this.marker = null
  }

  connectedCallback() {
    super.connectedCallback()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.marker && this.marker.remove()
  }

  initMarker(map) {
    this.marker = new mapboxgl.Marker(this.initialMarkerOptions).setLngLat(this._lngLat)
    !this._element && (this.marker.getElement().style['position'] = 'absolute')
    this.marker.addTo(map)
  }

  updateMarkerElements() {
    const shadowRootSlot = this.shadowRoot.querySelector('slot')

    if (shadowRootSlot) {
      const nodes = this.shadowRoot.querySelector('slot').assignedNodes({ flatten: true })
      const mapElements = nodes.filter(n => n.nodeName.slice(0, 7) === 'SBT-MAP')

      if (this.marker) {
        mapElements.forEach(n => n.marker = this)
      }

      this.element = nodes.find(n => n instanceof HTMLElement && n.nodeName.slice(0, 7) !== 'SBT-MAP')
    }
  }

}

customElements.define(SbtMapMarker.is, SbtMapMarker)